/**
 * DocumentTypes used in the application
 */
export const AddOnType = {
	AI_FUNCTIONS: 'AI_FUNCTIONS',
	SOCRATES: 'SOCRATES',
};

export const AddOnAccountType = {
	ORGANIZATION: 'ORGANIZATION',
	LOGIN: 'LOGIN',
};
